"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDateOfBirth = void 0;
const setDateOfBirth = (currentDate, yearsInPast) => {
    const date = new Date(Date.UTC(currentDate.getUTCFullYear() - yearsInPast, currentDate.getUTCMonth(), currentDate.getUTCDate()));
    return date;
};
exports.setDateOfBirth = setDateOfBirth;
//# sourceMappingURL=setDateOfBirth.js.map